import type { StudioPathLike } from '@sanity/client/csm';
import LinedHeading from '../components/LinedHeading';
import { Grid } from '../grid/Grid';
import type { TaggedGridItemDocument } from '../grid/TaggedGridItem';
import TaggedGridItem from '../grid/TaggedGridItem';
import type { KnownTypes } from '../page';
import type { KeyedArray } from '../types';
import type { FileComponentProps } from './fileComponent';
import FileComponent from './fileComponent';
import * as styles from './richText.module.css';

export interface GridProps {
    name?: string;
    items?: KeyedArray<FileComponentProps | TaggedGridItemDocument<KnownTypes>>;
}

function GridItem(value: FileComponentProps | TaggedGridItemDocument<KnownTypes>) {
    const type = value._type;
    if (type == 'fileComponent') {
        return <FileComponent value={value} />;
    } else {
        return <TaggedGridItem {...value} showCategory hideTags />;
    }
}

export default function GridBlock({ value, studioPath }: { value?: GridProps; studioPath?: StudioPathLike }) {
    if (!value?.items?.length) return null;
    return (
        <div className={styles.grid}>
            <LinedHeading>{value.name}</LinedHeading>
            <Grid items={value.items} component={GridItem} studioPath={studioPath} />
        </div>
    );
}
